import { Form, Input } from 'antd'
import { t } from 'i18next'
import { memo } from 'react'

const CreateDataStoreDetailsStep = memo(() => {
  return (
    <>
      <Form.Item
        name="title"
        label={t('createDataStoreModal.detailsStep.title')}
        extra={t(
          'createDataStoreModal.detailsStep.titleSubheader'
        )}
        rules={[
          {
            required: true,
            message: t('errorMessage.isRequired') || '',
          },
        ]}
      >
        <Input
          placeholder={
            t(
              'createDataStoreModal.detailsStep.inputPlaceHolder'
            ) || ''
          }
        />
      </Form.Item>
      <Form.Item
        name="description"
        label={t(
          'createDataStoreModal.detailsStep.description'
        )}
        extra={t(
          'createDataStoreModal.detailsStep.descriptionSubheader'
        )}
      >
        <Input.TextArea autoSize={{ minRows: 3, maxRows: 5 }} />
      </Form.Item>
    </>
  )
})

export default CreateDataStoreDetailsStep
